import { render } from "./ResponsiveImage.vue?vue&type=template&id=ad82fc08"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js"
script.render = render

export default script